// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".caption-loader[data-v-316ef34a]{max-width:320px}", "",{"version":3,"sources":["webpack://./src/content-loaders/caption-loader.vue"],"names":[],"mappings":"AAoBA,iCACE,eAAA","sourcesContent":["\n                @import '@quero/zilla-core/src/utils';\n              \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.caption-loader {\n  max-width: 320px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
